import { createFileRoute } from "@tanstack/react-router";
import MultitouchFlow from "@/features/assessments/pages/multitouch/MultitouchFlow";

export const Route = createFileRoute("/$locale/$partner/_evaluation/multitouch")({
	component: MultitouchFlow,
});
